import { OrderHistoryCardProps } from "@hatch-digital-nl/bravilor-storybook";
import { RefurbishedOrderHistoryInterface } from "../interfaces/apiV2/refurbished/RefurbishedOrderHistoryInterface";
import { LanguageInterface } from "../interfaces/shared/LanguageInterface";
import { formatOrderDate } from "./formatOrderDate";

const CANCELED_STATUS = "canceled";

interface OrderHistoryLabels {
    orderNumberLabel: string;
    orderDateLabel: string;
    serialNrLabel: string;
    priceLabel: string;
    canceledLabel: string;
}

export const mapOrderHistoryToCardProps = (
    order: RefurbishedOrderHistoryInterface,
    activeLanguage: LanguageInterface | null,
    labels: OrderHistoryLabels,
): OrderHistoryCardProps => {
    return {
        orderNumber: `#${order.id}`,
        orderDate: formatOrderDate(
            order.confirmed_at,
            activeLanguage?.localeCode,
        ),
        orderNumberLabel: labels.orderNumberLabel,
        orderDateLabel: labels.orderDateLabel,
        lines: order.order_lines.map((line) => ({
            id: line.id,
            name: line.product_name,
            image: line.product_image,
            serialNr: line.serial_number || undefined,
            price: line.discount_grade_price,
            serialNrLabel: labels.serialNrLabel,
            priceLabel: labels.priceLabel,
            isCanceled: line.status === CANCELED_STATUS,
            canceledLabel: labels.canceledLabel,
        })),
    };
};
